import type { UIStringsOverride } from "../i18n-ui.ts";

/** Vietnamese (vi) UI strings. */
export const vi: UIStringsOverride = {
  actions: {
    addToCursor: "Thêm vào Cursor",
    addToVscode: "Thêm vào VS Code",
    askAI: "Hỏi AI về trang này",
    connectMcp: "Kết nối với MCP",
    copied: "Đã sao chép!",
    copyClaudeCode: "Sao chép lệnh Claude Code",
    copyCode: "Sao chép mã",
    copyCodex: "Sao chép lệnh Codex",
    copyMarkdown: "Sao chép dưới dạng Markdown",
    copyServerUrl: "Sao chép URL máy chủ",
    edit: "Chỉnh sửa trên GitHub",
    export: "Xuất",
    exportEpub: "Xuất ra EPUB",
    exportPdf: "Xuất ra PDF",
    generating: "Đang tạo…",
    openIn: "Mở trong {name}",
    openInChat: "Mở trong trò chuyện",
    scrollToTop: "Lên đầu trang",
  },
  ask: {
    ai: "AI",
    clear: "Xóa cuộc trò chuyện",
    close: "Đóng",
    copy: "Sao chép cuộc trò chuyện",
    empty: "Đặt câu hỏi về tài liệu.",
    error: "Xin lỗi, đã xảy ra sự cố.",
    label: "Đặt câu hỏi",
    placeholder: "Đặt câu hỏi…",
    send: "Gửi",
    tip: "Mẹo: Bạn có thể mở và đóng trò chuyện bằng",
    title: "Hỏi AI",
    you: "Bạn",
  },
  banner: { dismiss: "Đóng thông báo" },
  changelog: {
    description: "Cập nhật sản phẩm và ghi chú phát hành.",
    showReleases: "Hiện các bản phát hành {version}",
    title: "Nhật ký thay đổi",
  },
  content: {
    diagramError: "Không thể hiển thị sơ đồ này.",
  },
  feedback: {
    no: "Không",
    question: "Trang này có hữu ích không?",
    thanks: "Cảm ơn phản hồi của bạn!",
    yes: "Có",
  },
  languageSwitcher: { label: "Ngôn ngữ", untranslated: "Chưa dịch" },
  nav: {
    back: "Quay lại",
    breadcrumb: "Đường dẫn điều hướng",
    closeNavigation: "Đóng điều hướng",
    deprecated: "lỗi thời",
    featured: "Nổi bật",
    githubRepository: "Kho lưu trữ GitHub",
    navigation: "Điều hướng",
    primary: "Chính",
    sections: "Chuyên mục",
    toggleNavigation: "Chuyển đổi điều hướng",
    toggleTheme: "Chuyển đổi chủ đề màu",
  },
  notFound: {
    description: "Chúng tôi không tìm thấy trang bạn đang tìm.",
    home: "Về trang chủ",
    title: "Không tìm thấy trang",
  },
  page: {
    lastUpdated: "Cập nhật lần cuối",
    next: "Tiếp theo",
    pagination: "Phân trang",
    previous: "Trước",
    skipToContent: "Chuyển đến nội dung",
  },
  search: {
    all: "Tất cả",
    allLanguages: "Tất cả ngôn ngữ",
    askAi: "Hỏi AI",
    askAiHint: "Nhận câu trả lời tức thì từ AI",
    button: "Tìm kiếm",
    devOnly: "Tìm kiếm có sẵn trong bản dựng production.",
    error: "Đã xảy ra sự cố. Vui lòng thử lại.",
    label: "Tìm kiếm tài liệu",
    navigate: "di chuyển",
    noResults: "Không tìm thấy kết quả.",
    open: "mở",
    placeholder: "Tìm kiếm tài liệu…",
    popular: "Phổ biến",
    preview: "xem trước",
    results: "Kết quả",
  },
  toc: { title: "Trên trang này" },
};
